import React, {useEffect, useContext} from 'react'
import {Checkbox, FormControlLabel, TextField, Button} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import {Autocomplete} from '@material-ui/lab'
import {ReservationConfigurationContext} from '../../../context/ReservationConfiguration'
import {useParams} from 'react-router'

const FTextField = ({data, onChange = (e, key, value) => {}}) => {
  const {additionalFieldValues, getAdditionalFieldValues} = useContext(
    ReservationConfigurationContext
  )
  const {group_id} = useParams()
  useEffect(() => {
    getAdditionalFieldValues(group_id, ['NumericField', 'CurrencyField'], true, true, false)
  }, [group_id, getAdditionalFieldValues])

  return (
    <>
      <Autocomplete
        multiple
        options={additionalFieldValues.data.data?.fields.map(option => option.name) || []}
        id="standard-required"
        label=""
        renderInput={params => (
          <TextField
            {...params}
            variant="standard"
            label="Calculation Formula"
            placeholder=""
            onKeyPress={event => {
              if (event.key === 'Enter') {
              }
            }}
          />
        )}
      />
      <Button>Clear Formula</Button>
    </>
  )
}

export default FTextField
